<template>
    <div class="flex flex-row justify-content-between w-full mb-3">

        <!-- LEFT -->
        <div class="left flex flex-row gap-1 align-items-center" id="filters">
            <div class="flex flex-row gap-3 align-items-center h-full mr-3">

                <!-- Advanced Filters button -->
                <div class="relative flex-row align-items-center">
                    <Button outlined type="button" @click="emit('toggle-show-filters')" :badge="`${numberOfFilters}`" class="">
                        <div class="flex flex-row align-items-center gap-2 px-1">
                            <SvgDockLeft className="table-licenses-svg" color="var(--button-normal-color)"/>
                            <div class="ml-1 flex flex-row align-items-center gap-1">
                                <SvgFilterOn className="button-svg" color="var(--button-normal-color)"/>
                                <span>Advanced Filters</span>
                            </div>
                        </div>
                    </Button>
                    <Badge v-if="numberOfFilters>0" :value="numberOfFilters" class="absolute" style="top: -0.5rem; right: -0.5rem;"></Badge>
                </div>

                <!-- Search bar -->
                <span class="p-input-icon-left p-input-icon-right h-full flex align-items-center">
                    <SvgSearch className="inputcomponent-right-svg" color="var(--theme-font-color)" style="top: 1.03rem;"/>
                    <InputText id="searchInputText" ref="searchInputText" v-model="searchValue" placeholder="Search Filter" type="text" style="padding-left: 2.1rem !important; padding-right: 2.1rem !important;"/>
                    <SvgCross className="inputcomponent-right-svg" color="var(--theme-font-color)" @click="searchValue = ''; isSearching = false" style="top: 1.03rem;"/>
                </span>
            </div>

            <Divider layout="vertical" style="padding: 0; padding-left: 0rem; padding-right: 0rem;"/>

            <!-- Add Serial button -->
            <Button text @click="addSerialNumber">
                <div class="flex flex-row w-full justify-content-center align-items-center gap-2">
                    <SvgPlus className="table-licenses-svg" color="var(--button-normal-color)"/>
                    <span>Add a Serial Number</span>
                </div>
            </Button>
        </div>

        <!-- RIGHT -->
        <div class="right flex flex-row justify-content-end align-items-center gap-1">

            <!-- Batch Actions -->
            <div class="relative mr-3">
                <Button class="actionsButton actionsButtonMain" text label="Batch Actions" icon="pi pi-chevron-down" @click="showActions = !showActions">
                    <span class="flex flex-row align-items-center gap-2" style="font-weight: 100;">
                        <span>Batch Actions</span>
                        <SvgChevronDown className="chevron-svg" color="var(--button-normal-color)"/>
                    </span>
                </Button>
                <div v-if="showActions" class="actionsWindow absolute flex flex-column align-items-start" style="z-index: 5000; background-color: var(--theme-color1); width: 12.2rem;" @blur="showActions = !showActions">
                    <div v-if="isActionsMenubarDisabled"
                        v-tooltip.bottom="{ value: `${selectedLicenses.some((license) => license.admin.id !== user.id) ? 'Make sure you are the owner of all selected licenses.' : 'Please select at least one license.'}`, showDelay: 500 }"
                    >
                        <Button class="actionsButton w-full" text label="Assign User(s)" @click="actionAssignUsers" disabled style="border-radius: 0px;">
                                <div style="width: 1.8rem;" class="flex flex-row align-items-center justify-content-start">
                                    <SvgAssignUsers className="table-licenses-svg" color="var(--button-normal-color)"/>
                                </div>
                                <span style="font-size: var(--button-font-size); font-weight: var(--button-secondary-font-weight);">Assign User(s)</span>     
                        </Button>
                        <Button class="actionsButton w-full" text label="Transfer Ownership" @click="actionTransferOwnership" disabled style="border-radius: 0px;">
                                <div style="width: 1.8rem;" class="flex flex-row align-items-center justify-content-start">
                                    <SvgUpgrade className="table-licenses-svg" color="var(--button-normal-color)"/>
                                </div>
                                <span style="font-size: var(--button-font-size); font-weight: var(--button-secondary-font-weight);">Transfer Ownership</span>     
                        </Button>
                    </div>
                    <div v-else>
                        <Button class="actionsButton w-full" text label="Assign User(s)" @click="actionAssignUsers" style="border-radius: 0px;">
                            <div style="width: 1.8rem;" class="flex flex-row align-items-center justify-content-start">
                                <SvgAssignUsers className="table-licenses-svg" color="var(--button-normal-color)"/>
                            </div>
                            <span style="font-size: var(--button-font-size); font-weight: var(--button-secondary-font-weight);">Assign User(s)</span>
                        </Button>
                        <Button class="actionsButton w-full" text label="Transfer Ownership" @click="actionTransferOwnership" style="border-radius: 0px;">
                            <div style="width: 1.8rem;" class="flex flex-row align-items-center justify-content-start">
                                <SvgUpgrade className="table-licenses-svg" color="var(--button-normal-color)"/>
                            </div>
                            <span style="font-size: var(--button-font-size); font-weight: var(--button-secondary-font-weight);">Transfer Ownership</span>
                        </Button>
                    </div>
                </div>
            </div>

            <!-- Refresh button -->
            <Button rounded text @click="$emit('refresh-licenses-table');" style="border-radius: 980px; padding: 0.5rem;">
                <SvgRefresh className="table-licenses-svg" color="var(--button-normal-color)"/>
            </Button>

            <Divider layout="vertical" style="padding: 0; padding-left: 0rem; padding-right: 0rem;" class="ml-3 mr-5"/>

            <!-- My Users button -->
            <div class="relative">
                <Button outlined id="users-button" type="button" @click="emit('toggle-show-users')">
                    <div class="flex flex-row align-items-center gap-2 px-1">
                        <div class="mr-1 flex flex-row align-items-center gap-1">
                            <SvgUsers className="table-licenses-svg" color="var(--button-normal-color)"/>
                            <span>Users</span>
                        </div>
                        <SvgDockRight className="table-licenses-svg" color="var(--button-normal-color)"/>
                    </div>
                </Button>
                <Badge v-if="userFilterOn" value="!" class="absolute" style="top: -0.5rem; left: -0.5rem;"/>
            </div>
        </div>
    </div>


    <!-- DIALOGS -->

    <!-- Add Serial Number window -->
    <AddSerialNumberDialog :showDialog="showAddSerialNumberDialog" @close="showAddSerialNumberDialog = false"/>

    <!-- Attach/Detach User(s) window -->
    <AssignUsersDialog v-if="showAssignUsersDialog" :showDialog="showAssignUsersDialog" :selectedLicenses="selectedLicenses" @close="showAssignUsersDialog = false" @refresh-licenses-table="$emit('refresh-licenses-table')"/>

    <!-- Transfer Ownership window -->
    <TransferOwnershipDialog v-if="showTransferOwnershipDialog" :showDialog="showTransferOwnershipDialog" :selectedLicenses="selectedLicenses" @close="showTransferOwnershipDialog = false" @refresh-licenses-table="$emit('refresh-licenses-table')"/>
</template>

<script setup>
// --- IMPORTS ---
import { ref, toRefs, watchEffect, onMounted, onBeforeUnmount, computed } from 'vue'
// PrimeVue
import Button from 'primevue/button'
import Badge from 'primevue/badge'
import InputText from 'primevue/inputtext'
import Divider from 'primevue/divider'
// vue
import AddSerialNumberDialog from '@/components/Dialogs/Actions/AddSerialNumberDialog.vue'
import AssignUsersDialog from '@/components/Dialogs/Actions/AssignUsersDialog.vue'
import TransferOwnershipDialog from '@/components/Dialogs/Actions/TransferOwnershipDialog.vue'
import SvgDockLeft from '@/components/SVGs/SvgDockLeft.vue'
import SvgDockRight from '@/components/SVGs/SvgDockRight.vue'
import SvgUsers from '@/components/SVGs/SvgUsers.vue'
import SvgSearch from '@/components/SVGs/SvgSearch.vue'
import SvgCross from '@/components/SVGs/SvgCross.vue'
import SvgPlus from '@/components/SVGs/SvgPlus.vue'
import SvgAssignUsers from '@/components/SVGs/SvgAssignUsers.vue'
import SvgUpgrade from '@/components/SVGs/SvgUpgrade.vue'
import SvgRefresh from '@/components/SVGs/SvgRefresh.vue'
import SvgChevronDown from '@/components/SVGs/SvgChevronDown.vue'
import SvgFilterOn from '@/components/SVGs/SvgFilterOn.vue'
// Others
import toastService from '@/composables/toastService';
import { useStore } from 'vuex';

const store = useStore()

// --- PROPS ---
const props = defineProps({
    numberOfFilters: Number,
    visibleFilters: Boolean,
    selectedLicenses: Array,
    userFilterOn: Boolean,
    selectedUser: Object,
    visibleUsers: Boolean
})
const { selectedLicenses } = toRefs(props)

// --- User info ---
const user = computed(() => store.state.user.user)

// --- EMITS ---
const emit = defineEmits(['toggle-show-filters', 'search-value-changed', 'refresh-licenses-table','toggle-show-users'])

// --- Global filtering ---
const searchValue = ref(null)
watchEffect(() => {
    emit('search-value-changed', searchValue.value ? searchValue.value : '')
})

// --- Add a serial number (click on button) ---
const showAddSerialNumberDialog = ref(false)
const addSerialNumber = (event) => {
    showAddSerialNumberDialog.value = true
}

// --- Actions ---
const isActionsMenubarDisabled = ref(true)
watchEffect(() => { // Whenever selectedLicenses changes, it verifies if it has at least one item : to know if actions menubar enabled or not
    isActionsMenubarDisabled.value = selectedLicenses.value.length===0 || selectedLicenses.value.some((license) => license.admin.id !== user.value.id)
})
// Overlay
const showActions = ref(false)
const handleClick = (event) => {
    if (!event.target.closest('.actionsWindow') && !event.target.closest('.actionsButton')) {
        showActions.value = false
    }
};
onMounted(() => {
  document.body.addEventListener('click', handleClick);
});
onBeforeUnmount(() => {
  document.body.removeEventListener('click', handleClick);
});

// Assign User(s)
const showAssignUsersDialog = ref(false)
const actionAssignUsers = (event) => {
    // I can assign ONLY if all the selected licenses are MINE (I am the owner)
    if (selectedLicenses.value.some((license) => license.admin.id !== user.value.id)) {
        toastService.add({ severity: 'error', summary: "Assign User(s): Error", detail: 'You must be the owner of all selected licenses to assign user(s).', life: 5000 });
        return;
    }
    showAssignUsersDialog.value = true
}

// Transfer Ownership
const showTransferOwnershipDialog = ref(false)
const actionTransferOwnership = (event) => {
    // I can assign ONLY if all the selected licenses are MINE (I am the owner)
    if (selectedLicenses.value.some((license) => license.admin.id !== user.value.id)) {
        toastService.add({ severity: 'error', summary: "Transfer Ownership: Error", detail: 'You must be the owner of all selected licenses to transfer their ownership.', life: 5000 });
        return;
    }
    showTransferOwnershipDialog.value = true
}
</script>

<style scoped>
/* ACTIONS MENUBAR */
.actionsButtonMain:hover {
    background-color: transparent;
}
.actionsButton:not(.actionsButtonMain) {
    background-color: var(--theme-color1);
}
.actionsButton:not(.actionsButtonMain):hover {
    background-color: var(--theme-background-color);
}
#actions-menubar {
    z-index: 3000;
}
:deep(.p-menubar) {
    border: transparent;
    background-color: transparent;
}
:deep(.p-menubar .p-menuitem-icon), :deep(.p-menubar .p-icon) {
    color: var(--button-primary-color);
}
:deep(.p-submenu-list) {
    border: none;
}
:deep(.p-submenu-list .p-menuitem) {
    padding: 0.8rem 0rem;
}
:deep(.p-submenu-list) {
    background-color: var(--theme-color1);
}
:deep(.p-submenu-list .p-menuitem) {
    background-color: var(--theme-color1);
}
:deep(.p-submenu-list .p-menuitem:hover) {
    background-color: var(--theme-background-color);
}
:deep(.p-menuitem-content:hover, .p-menuitem-content:active) {
    background-color: transparent;
}
:deep(.p-menuitem-link) {
    padding-top: 0rem;
    padding-bottom: 0rem;
}
:deep(.p-menuitem-link .p-menuitem-text, .p-menubar .p-icon) {
    color: var(--button-primary-color);
    font-weight: 200;
}
</style>